const parsePayerApplications = (applications) => {
  if (applications === '' || !applications) {
    return [];
  }

  const appList = applications;

  appList.forEach((application, i) => {
    const lowerCaseApp = application.toLowerCase();
    if (lowerCaseApp === 'tmt') {
      appList[i] = 'track-my-ticket';
    } else if (lowerCaseApp === 'paan') {
      appList[i] = 'prior-auth';
    } else if (lowerCaseApp === 'fee schedule lookup') {
      appList[i] = 'feeschedulelookup';
    } else {
      appList[i] = lowerCaseApp.replace(/ /g, '-');
    }
  });

  return appList;
};

export const parsePayers = (data, payload) => {
  // const payers = data.payers || [];
  let defaultPayerId = 0;

  // map the key back to the id for use in redux
  // change all applications in the item to a list and parse

  const payers = (data.payers || []).map((payer, index) => {
    const { key, label, name, applications } = payer;

    if (payer.key === '87726') {
      defaultPayerId = index;
    }

    const payerCopy = {
      id: key,
      label,
      name,
      applications: parsePayerApplications(applications),
    };
    return payerCopy;
  });

  if (payload && payload.application && payload.application !== 'referral') {
    return payers.filter((payer) => {
      return payer.applications.includes(payload.application);
    });
  }

  const orderedPayers = [payers[defaultPayerId], ...payers];
  orderedPayers.splice(defaultPayerId + 1, 1);

  return orderedPayers;
};
